import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import formStyles from '../../../styles/forms.module.scss';
import {
  TextInput,
  RadioGroupInput,
  AccessibleDatepickerInput,
} from '../../../common/FormFields';
import Heading from '../../../common/Heading';
import s from './StepCertificateForm.module.scss';

function StepProofOfOriginForm() {
  const namePrefix = 'proofOfOriginCertificateData.';

  return (
    <section>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.StepProofOfOrigin.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPair}>
          <Field
            name="information.start"
            labelMsg="offerWizard.StepSomeInformation.start.label"
            component={AccessibleDatepickerInput}
            minDate={new Date()}
          />
          <Field
            name="information.end"
            labelMsg="offerWizard.StepSomeInformation.end.label"
            component={AccessibleDatepickerInput}
            minDate={(values) => {
              if (values.information && values.information.start) {
                return new Date(values.information.start);
              }
              return new Date();
            }}
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={`${namePrefix}consumption`}
            component={TextInput}
            labelMsg="offerWizard.StepProofOfOrigin.consumption.label"
          />
        </div>
        <Field
          captionMsg="offerWizard.StepProofOfOrigin.certification"
          name={`${namePrefix}certification`}
          options={[
            {
              value: 'ee',
              labelText: 'TÜV Süd EE',
            },
            {
              value: 'ee_plus',
              labelText: 'TÜV Süd EE+',
            },
            {
              value: 'ee_new',
              labelText: 'TÜV Süd EE neu',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.certificationRadios}
        />
        <Field
          captionMsg="offerWizard.StepProofOfOrigin.origin"
          name={`${namePrefix}origin`}
          options={[
            {
              value: 'de',
              labelText: 'Deutschland',
            },
            {
              value: 'de_at_ch',
              labelText: 'D-A-CH',
            },
            {
              value: 'eu',
              labelText: 'Europa',
            },
            {
              value: 'at',
              labelText: 'Österreich',
            },
            {
              value: 'de_at_ch_fr',
              labelText: 'D-A-CH + Frankreich',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.originRadios}
        />
      </div>
    </section>
  );
}

StepProofOfOriginForm.propTypes = {};

export default StepProofOfOriginForm;
